<template>
  <div class="">
    <com-head :leadtext="toptext"></com-head>
    <div class="menu-key">
      <p class="enter-text">部分代表企业 </p>
      <ul class="entimg">
        <li
          v-for="(list, index) in listimg"
          :class="{ selected: index == isactive }"
          @click="entclick(index)"
        >
          <img :src="list.logo" alt="" />
        </li>
      </ul>
      <p class="enter-text">产品类别-<span>(内容由企业提供，CPS中安网整理)</span></p>
          <el-tabs v-model="activeName" type="card" @click="keyid" @tab-click="handleClick">
            <el-tab-pane
              v-for="(list, index) in antarray"
              :key="index"
              :label="list.title"
              :name="index.index"
              :id="list.id"
            >
              
            </el-tab-pane>
          </el-tabs>
    </div>
    <div class="menu-key">
      <div class="key-content">
          <div class="keycon-title">
            <h3>{{title}}</h3>
            <div class="aa"></div>
          </div>
          <div v-html="entcentent"  id="content-style-pro">
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import comhead from "./comhead.vue";
import { trend, scheme} from "../api/api";

export default {
  components: {
    "com-head": comhead,
  },
  data() {
    return {
      isactive: 0, //默认第一个有样式
      toptext:
        "5G、AI、大数据等前沿技术在2020年，全方位融入到安防行业多元的应用场景中，软件定义摄像机、AI摄像机、生物识别一体机等新产品，通过技术创新赋能，开拓行业应用，正在走向广阔的“实战”领域。",
      antarray: [
        {
          content: "",
          create_time: 0,
          keyword: "",
          title: "",
        },
      ],
      listimg: [
        {
          id: 0,
          image: "",
          pid: 0,
          title: "",
        },
      ],
       title: "",
      entcentent: "",
      id: 0,
      // 关键词默认值
      activeName: "0",

      //折叠面板默认值
      activeNames: ["1"],
      logowidth: 0,//控制logo长度使用值
    };
  },
   methods: {
    //获取数据
    getData: function () {
      console.log("sds");
      var gain = {
        cate_id: 84,
        where: '[year,=,2020]',
      };
      scheme(gain).then((res) => {
        this.antarray = res.data;
        this.keyid(this.antarray[0].id)
      });
      
    },
    handleClick: function(tab) {
       this.logowidth = 0
        var  name = this.antarray[tab.index].id
         var gain = {
        cate_id: name,
        where: '[year,=,2020]',
         limit: 40,
      };
      trend(gain).then((res) => {
        this.listimg = res.data.list;
        this.entclick(0)
      });
         this.logowidth = name;
      },

    //产品类别点击
    keyid: function(name){
        this.logowidth = 0
         var gain = {
        cate_id: name,
        where: '[year,=,2020]',
         limit: 40,
      };
      trend(gain).then((res) => {
        this.listimg = res.data.list;
        this.entclick(0)
      });
         this.logowidth = name;
    },
    //企业logo点击
    entclick: function(id){
      this.title = "",
      this.entcentent = "",
      this.title = this.listimg[id].title
      this.entcentent = this.listimg[id].content
       this.isactive=id;
    }
  },
  mounted() {
    this.getData();
  },
  //修改加载后元素样式
  updated(){
    console.log(this.logowidth)
    if(this.logowidth==86){
       $('.entimg li').eq(0).css({'width':'258px'})
       $('.entimg li').eq(1).css({'width':'258px'})
       
    }else if(this.logowidth==90){
      $('.entimg li').eq(0).css({'width':'258px'})
      $('.entimg li').eq(1).css({'width':'108px'})
    }else{
      $('.entimg li').css({'width':'108px'})
    }
      
  }
};
</script>

<style lang="less" scoped>
@import "../assets/public.less";
.menu-key{
  padding: 30px;
}
.selected {
  border: 2px solid !important;
  border-image: linear-gradient(
      270deg,
      rgba(56, 18, 178, 0.5),
      rgba(250, 29, 129, 0.5)
    )
    4 4 !important;
}
.key-content {
  border-top: 0;
  padding: 50px;
}
.menu-key {
  
  margin: 15px 0px;
  background: #ffffff;
}
/deep/.key-content h5 {
  font-family: PingFang SC;
  margin-top: 30px !important;
  text-align: left;
  margin: 30px 0px;
  margin-left: -30px;
}
#content-style-tre {
  color: #666666;
  width: 100%;
  margin-top: 30px;
}
</style>
<style scoped>
/* 表格样式 */
.key-content >>> table {
  width: 100% !important;
  font-size: 12px !important;
}
.key-content >>> table tr {
  height: 41px !important;
  border-top: 1px solid #ececec !important;
  text-align: center !important;
}
.key-content >>> table tr:nth-child(1) td {
  font-size: 18px !important;
  color: #666666 !important;
}
.key-content >>> table tr td {
  font-size: 16px !important;
  color: #666666 !important;
  border-bottom: 1px solid #ececec !important;
}
.key-content >>> table tr td span {
  color: #666666 !important;
}
.key-content >>> table tbody tr:nth-child(1) {
  background: #f9f9fa !important;
  font-weight: bold !important;
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/product.vue